import React, { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  getWidgetsByPropertyId,
  handleActiveVistorSound,
  updateWidget,
} from "./APIs/firebaseWidgetSettingsApis";
import { Col, Row, Spin, message } from "antd";
import WidgetName from "./components/WidgetName";
import WidgetStatus from "./components/WidgetStatus";
import ForcedPopup from "./components/ForcedPopup";
import PreChatForm from "./components/PreChatForm";
import WidgetAppearance from "./components/WidgetAppearence";
import CountryRestriction from "./components/CountryRestriction";
import DomainRestriction from "./components/DomainRestriction";
import FeaturesSettings from "./components/FeaturesSettings";
import VisibilitySettings from "./components/VisibilitySettings";
import WidgetCode from "./components/WidgetCode";
import OperatingHours from "./components/OperatingHours";
import TimeZones from "./components/TimeZones";
import PlatformRestriction from "./components/PlatformRestriction";
import VisitorIdleTime from "./components/VisitorIdleTime";
import NotificationSettings from "./components/NotificationSettings";
import { useDispatch, useSelector } from "react-redux";
import { updateUser } from "../../firebase/queries";

const WidgetSettings = () => {
  const propertyId = useParams()?.propertyId;
  const user = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(true);
  const [widget, setWidget] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (propertyId) {
      const fetchWidget = async () => {
        setLoading(true);
        const response = await getWidgetsByPropertyId(propertyId).finally(
          () => {
            setLoading(false);
          }
        );
        setWidget({
          ...response,
          propertyId: propertyId,
        });
      };
      fetchWidget();
    }
  }, [propertyId]);

  const widgetChangeCallback = useCallback(
    async (updatedWidget) => {
      setLoading(true);
      await updateWidget(propertyId, updatedWidget.id, updatedWidget)
        .catch((err) => {
          console.log(err);
          message.error("Something went wrong.");
          return null;
        })
        .finally(() => {
          setLoading(false);
        });
      setWidget((prevState) => ({ ...prevState, ...updatedWidget }));
      message.info("Updated!");
    },
    [propertyId]
  );

  const handleSoundCallback = useCallback(
    async (updatedWidget) => {
      setLoading(true);

      let response = await handleActiveVistorSound(user?.id, updatedWidget)
        .catch((err) => {
          console.log(err.message);
          message.error("Something went wrong.");
          return null;
        })
        .finally(() => {
          setLoading(false);
        });
      if (response) {
        let { id, ...rest } = response;
        let updateUserObj = { ...user, ...rest };
        dispatch(updateUser(updateUserObj));
        message.info("Updated");
      }
    },
    [propertyId]
  );

  const handleBackButtonClick = useCallback(() => {
    navigate(`/properties`);
  }, []);
  return (
    <>
      <div>
        <button className="backBtn" onClick={handleBackButtonClick}>
          <i className="fa-solid fa-arrow-left"></i>
          Back
        </button>
      </div>

      <Spin spinning={loading}>
        <Row gutter={[12, 16]}>
          <Col lg={12} xs={24}>
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <WidgetName
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <WidgetStatus
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <ForcedPopup
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <PreChatForm
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <WidgetAppearance
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <CountryRestriction
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>

              <Col span={24}>
                <DomainRestriction
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>

              <Col span={24}>
                <FeaturesSettings
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>

              <Col span={24}>
                <VisibilitySettings
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
            </Row>
          </Col>
          <Col lg={12} xs={24}>
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <WidgetCode
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <OperatingHours
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <TimeZones
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <PlatformRestriction
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <VisitorIdleTime
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                />
              </Col>
              <Col span={24}>
                <NotificationSettings
                  widget={widget}
                  handleWidgetChange={widgetChangeCallback}
                  handleSound={handleSoundCallback}
                  user={user}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </Spin>
    </>
  );
};

export default WidgetSettings;
